import React from 'react';
import { RichContent } from '../elements/RichContent';

export const CorporateContactDetails = (props) => {
    const {corporateAddress, mobileNumber} = props.content;

    return (
        corporateAddress &&
        <section className="kiwi-contact__corporate">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                    <h3 className="h3">Address</h3>
                        <RichContent dangerous={corporateAddress} />
                        <p className="p-tag">{mobileNumber}</p>
                    </div>
                </div>
            </div>
        </section>
    )
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/CorporateContactDetails.js